import { render, staticRenderFns } from "./userBadge.vue?vue&type=template&id=2175739a&"
import script from "./userBadge.vue?vue&type=script&lang=js&"
export * from "./userBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports